import { render, staticRenderFns } from "./LandingFeaturesSlider.vue?vue&type=template&id=624fb1fe"
import script from "./LandingFeaturesSlider.vue?vue&type=script&lang=js"
export * from "./LandingFeaturesSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports